/*
 * 智能会议平板
 */
import React from 'react';
import cn from 'classnames';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import Scheme from 'components/product/scheme';
import Contact from 'components/contact';
import style from './index.module.scss';

const IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/hard/TP650/';

const bannerList = [
  {
    title: '智能会议平板',
    pcUrl: 'bg0.jpg',
    mUrl: 'm/bg0.jpg',
    desc: '集专业远程会议、白板协作、无线投屏等多种应用于一体\n全方位智能化体验，去繁就简高效协同',
    mDesc: '集专业远程会议、白板协作、无线投屏等多种\n应用于一体\n全方位智能化体验，去繁就简高效协同',
    type: 4,
    className: style.firstBanner,
  },
  {
    title: '原生云视频，高品质连接',
    pcUrl: 'bg1.jpg',
    mUrl: 'm/bg1.jpg',
    desc: '内置专用编解码芯片，体验高品质云视频连接',
    type: 3,
    className: style.banner1,
  },
  {
    AI: [
      {
        title: '4K超高清摄像头，满足人脸识别、智能取景、声源定位',
        mTitle: '4K超高清摄像头，满足人脸识别、智能取景、\n声源定位',
        pcUrl: IMG_PRE + 'AI-img0.jpg',
      },
      {
        title: '支持自动切换发言人特写画面',
        pcUrl: IMG_PRE + 'AI-img1.jpg',
      },
    ],
  },
  {
    title: '无线投屏，协作更自由',
    pcUrl: 'bg3.jpg',
    mUrl: 'm/bg3.jpg',
    desc: '支持无线传屏器、各类客户端等全场景投屏\n手势操作轻松调出截图、批注、视频源等快捷工具',
    mDesc: '',
    type: 4,
    className: style.banner3,
  },
  {
    title: '开放办公，纵享多应用',
    pcUrl: 'bg4.jpg',
    mUrl: 'm/bg4.jpg',
    desc: 'Android、Windows双系统一键切换\n海量第三方应用开放安装\n丰富接口、兼容多种外设、满足双流',
    mDesc: '',
    type: 3,
    className: style.banner2,
  },
  {
    title: '灵活白板，表达不受限',
    pcUrl: 'bg5.png',
    mUrl: 'm/bg5.jpg',
    desc: '4096级压感书写、笔锋细腻呈现\n一屏双显、分屏白板协作',
    type: 4,
    className: style.banner3,
  },
];
const scene = [
  {
    title: '小型会议室商务洽谈',
    pcUrl: IMG_PRE + 'scene-img0.jpg',
  },
  {
    title: '分支机构会议会商',
    pcUrl: IMG_PRE + 'scene-img1.jpg',
  },
  {
    title: '开放办公空间协作',
    pcUrl: IMG_PRE + 'scene-img2.jpg',
  },
  {
    title: '医院科室远程会诊研讨',
    pcUrl: IMG_PRE + 'scene-img3.jpg',
  },
];

const Index = () => {
  return (
    <Wrapper title="智能会议平板" menuIndex="2" current={5} customClass={style.tp650}>
      {bannerList.map((item: any, index: number) => {
        return index === 2 ? (
          <Scheme animate="fadeIn" delay={0.5} data={bannerList[2].AI} title={'AI应用，沉浸式追踪'} className={cn(style.ai)} bgImg={`${IMG_PRE}bg2.jpg`} mBgImg={`${IMG_PRE}m/bg2.jpg`} />
        ) : (
          <MultipleBanner {...item} animate={'fadeIn'} delay={0.5} descCenter key={item.title} imageHost={IMG_PRE} className={cn(style.banner, item.className)} />
        );
      })}
      <div className={style.outlineWrapper}>
        <div className={style.outline}>
          <div className={style.title}>匠心工艺，高端质感</div>
          <div className={style.outlineWrap}>
            {new Array(4).fill('').map((item: string, index: number) => {
              return <img className={style.outlineItem} key={index} src={`${IMG_PRE}desk-icon${index}.jpg`} alt="" />;
            })}
          </div>
        </div>
      </div>
      <Scheme data={scene} title={'应用场景'} className={style.scene} />
      <Contact className={style.contact} />
    </Wrapper>
  );
};

export default Index;
